//React
import React from 'react';

// Mantine

//Columns
import { CreditColumns } from 'columns/Credit';

//Components
import { BillingDataGridWrapper } from 'components/common/BillingDataGridWrapper';

//Interfaces
import { Credit } from 'interfaces';

//MRT
import { MRT_Cell, MRT_ColumnDef, MRT_TableOptions } from 'mantine-react-table';
import { TableAlertBanner } from 'components/common/TableAlertBanner';
import { DownloadButton } from 'components/common/DownloadButton';

interface CreditManagementProps {
  credits: Credit[];
  isLoading: boolean;
  isError: boolean;
  isFetching: boolean;
  errorMessage: string;
}

export const CreditManagement: React.FC<CreditManagementProps> = ({
  credits,
  isError,
  isLoading,
  isFetching,
  errorMessage,
}) => {
  const title = 'Credits';
  const columns: MRT_ColumnDef<Credit>[] = CreditColumns();

  const tableOptions: MRT_TableOptions<Credit> = {
    data: credits || [],
    columns,
    state: {
      showProgressBars: isFetching,
      showLoadingOverlay: isLoading,
      showAlertBanner: isError,
      showSkeletons: isLoading,
    },
    enableRowActions: true,
    mantineToolbarAlertBannerProps: () =>
      TableAlertBanner({ isError, message: errorMessage }),
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: 'Download',
        Cell: ({ cell }: { cell: MRT_Cell<Credit> }) => {
          const filename = cell.row.original.filename;
          if (!filename) return null;
          return (
            <DownloadButton
              bucket="qbilling-income-files"
              filename={filename}
            />
          );
        },
      },
    },
  };

  return (
    <>
      <BillingDataGridWrapper
        title={title}
        tableOptions={tableOptions}
        dataTestID="claimsManagement"
      />
    </>
  );
};
